module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    staticClass: "qDescript",
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [(_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', {
    staticClass: "queNum"
  }, [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('b', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "qsamllStem",
    domProps: {
      "innerHTML": _vm._s(_vm.fillFormatHtml(_vm.question.stem))
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.question.options), function(option, $index) {
    return (_vm.isShowAnswer) ? _c('div', [_c('div', {
      staticClass: "u-question-item"
    }, [_c('span', {
      staticClass: "color-999999"
    }, [_vm._v("学生答案：")]), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.setFillingAnswer(_vm.question.userAnswer, $index))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fr u-question-r"
    }, [_c('div', {
      staticClass: "assessIconBox f-error_txt",
      domProps: {
        "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question, $index))
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setNewAns(_vm.question, $index)
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
      staticClass: "col-red",
      domProps: {
        "innerHTML": _vm._s(_vm.setAssessFilling(_vm.question, $index))
      }
    }), _vm._v(" / " + _vm._s(parseFloat((_vm.question.question_ref_sorce / _vm.question.options.length).toFixed(1)) || 0) + "分）")]), _vm._v(" "), (_vm.handle == $index) ? _c('div', {
      staticClass: "handleScore clearfix"
    }, [_c('span', {
      staticClass: "correcting",
      class: {
        half_right: _vm.halfRight, half_right_hover: !_vm.halfRight
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleHr(_vm.question, $index)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "correcting",
      class: {
        C_right: _vm.Cright, C_right_hover: !_vm.Cright
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleCr(_vm.question, $index)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "correcting",
      class: {
        C_error: _vm.C_error, C_error_hover: !_vm.C_error
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleCe(_vm.question, $index)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scoreVal),
        expression: "scoreVal"
      }],
      staticClass: "scoreNow",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.scoreVal)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        },
        "change": function($event) {
          _vm.checkPrice(_vm.question, $index, _vm.scoreVal)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.scoreVal = $event.target.value
        }
      }
    }), _vm._v("\n                            分\n                            "), _c('input', {
      staticClass: "scoreSure",
      attrs: {
        "type": "button",
        "value": "确定"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.sentNewSocre(_vm.question, $index, _vm.scoreVal)
        }
      }
    })]) : _vm._e()])])]) : _vm._e()
  }), _vm._v(" "), (_vm.moduleId == 15) ? _c('listenTabTopic', {
    attrs: {
      "infoAnswer": _vm.question.options,
      "listenTextModule": _vm.question.textModule[0],
      "qtype": 3
    }
  }) : _c('tabTopic', {
    attrs: {
      "isObject": false,
      "infoAnswer": _vm.question.options,
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "tags": _vm.question.tags,
      "qtype": 3
    }
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-05859b8d","hasScoped":false}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/question/filling.vue
// module id = 177
// module chunks = 1